<template>
  <BaseAnimation
    :attr="{
      opacity: 1,
      y: 0,
      delay: 0.25 * index
    }"
  >
    <li class="animation-shape">
      <div class="participation__item-inner">
        <ShapeNumberItem :index="index" src="shape-number" />
      </div>
      <BaseCaption v-if="item.caption" :text="item.caption" />
      <BaseText v-if="item.descr" :text="item.descr" />
    </li>
  </BaseAnimation>
</template>

<script>
import ShapeNumberItem from '~/components/ShapeNumberItem'

export default {
  props: {
    item: {
      required: true,
      type: Object
    },
    index: {
      required: true,
      type: Number
    }
  },
  components: {
    ShapeNumberItem
  }
}
</script>

<style lang="scss">
.animation-shape {
  opacity: 0;
  transform: translate3d(0, -30px, 0);

  @for $i from 1 through 3 {
    &:nth-of-type(#{$i}) {
      .animation-number {
        animation: 2s ease-in #{$i}s infinite alternate swing;
      }
    }
  }
}

@keyframes swing {
  0% {
    transform: rotate(0);
  }
  25% {
    transform: rotate(10deg);
  }
  50% {
    transform: rotate(-5deg);
  }
  75% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(5deg);
  }
}
</style>



// WEBPACK FOOTER //
// components/ShapeListItem.vue